module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_BourgogneRed.70d71630.png";